/** Public marketing site origin (legal docs are hosted there). */
export const marketingOrigin = "https://veritrellis.ai";

export const marketingLegalUrl = (path: string): string => {
  const segment = path.startsWith("/") ? path.slice(1) : path;
  return `${marketingOrigin}/legal/${segment}`;
};

/** Matches veritrellis.ai marketing footer legal links. */
export const marketingFooterLegalLinks = [
  { label: "All legal", path: "" },
  { label: "Terms", path: "terms" },
  { label: "Privacy", path: "privacy" },
  { label: "Cookies", path: "cookies" },
  { label: "DPA", path: "dpa" },
  { label: "Subprocessors", path: "subprocessors" },
  { label: "Security", path: "security" },
  { label: "Vulnerability disclosure", path: "vulnerability-disclosure" }
] as const;

export const marketingFooterLegalHref = (path: string): string =>
  path.length === 0 ? `${marketingOrigin}/legal` : marketingLegalUrl(path);
